import formItemMixin from '@/components/form/mixins/formItemMixin'
export default {
  mixins: [formItemMixin],
  mounted() {
    this.init()
  },
  methods: {
    init() {
      this.data = window.eagleLodash.cloneDeep(this.storeData)
    },
  },
  computed: {
    isFinished() {
      if(!this.requiredFinished) return false
      if(!this.isValidEmail) return false
      if(!this.isValidPhone) return false
      if(!this.isValidPassword) return false
      if(!this.customValidateResult) return false
      return true
    },
    vuetifyRules() {
      let rules = window.eagleLodash.cloneDeep(this.baseVuetifyRules)
      if(this.isEmailType) {
        rules.push(this.emailRule)
      }
      if(this.validatePasswordStrength) {
        rules.push(this.passwordStrengthLevelRule)
      }
      if(this.minLengthRule) {
        rules.push(this.minLengthRule)
      }
      if(this.isPhoneType) {
        rules.push((value) => this.$helper.validator.phoneNumberLocalRule(value))
      }
      return rules
    },
    minLengthRule() {
      if(!this.formDataItem.minlength) return null
      return this.$helper.validator.minTextRule(this.data, this.formDataItem.minlength)
    },
    isEmailType() {
      return this.formDataItem.email === true
    },
    isValidEmail() {
      if(!this.isEmailType) return true
      if(!this.required) {
        if(!this.data) return true
      }
      if(!this.data) return false
      return this.$helper.validator.email(this.data)
    },
    isPhoneType() {
      return this.formDataItem.phone === true
    },
    isValidPhone() {
      if (!this.isPhoneType) return true
      if (!this.required) {
        if (!this.data) return true
      }
      if (!this.data) return false
      // 使用 phoneNumberLocal 來驗證手機號碼
      return this.$helper.validator.phoneNumberLocal(this.data)
    },
    isValidPassword() {
      if(!this.password) return true
      if(!this.validatePasswordStrength) return true
      if(this.passwordStrengthLevel === null) return false
      return this.passwordStrengthLevel != 'weak'
    },
    emailRule() {
      return value => this.$helper.validator.emailRule(this.data)
    },
    passwordStrengthLevelRule() {
      return value => this.passwordStrengthLevel != 'weak' || this.$t('validate.error.password.too_weak')
    },
    maxlength() {
      return this.formDataItem.maxlength || 50
    },
    placeholder() {
      return this.formDataItem.placeholder
    },
  },
  watch: {
    data: {
      deep: true,
      handler() {
        if(window.eagleLodash.isEqual(this.data, this.storeData)) return
        this.sync()
      },
    },
  }
}
